if ( objects.is_front_page || objects.is_template_front_page ) {
    gsap.registerPlugin(CSSPlugin, CSSRulePlugin)
    let playing = false

    /**** CANVAS ****/
    let scrollbarWidth = window.innerWidth - document.querySelector('body').getBoundingClientRect().width
    const canvas = document.getElementById("canvas")
    const ctx = canvas.getContext("2d")
    let w = ctx.canvas.width = 600
    let h = ctx.canvas.height = 600


    function resize() {
        scrollbarWidth = window.innerWidth - document.querySelector('body').getBoundingClientRect().width
        w = ctx.canvas.width = window.innerWidth - scrollbarWidth
        h = ctx.canvas.height = window.innerHeight
    }
    //window.addEventListener('resize', resize)
   // setTimeout(() => { resize() }, 500)

    function clear(){
        ctx.beginPath()
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.closePath()
    }
    /**** END CANVAS ****/


    /**** VISUALIZER ****/
    let frequencyDataLen = null;

    let config = {
        circleRadius: 120,
        multiplier: .5,
        frequencyRange: [5, 55],
        maxTraitHeight: 500,
        smoothingFactor: 0.1
    };

    let assignedFrequencies = []; // Tableau pour stocker les fréquences attribuées

    function assignFrequenciesSymmetrically() {
        let points = frequencyData.length; // Un point pour chaque donnée de fréquence
        let quarterPoints = points / 4; // Un quart des points pour la symétrie à 4 axes
    
        for (let i = 0; i < quarterPoints; i++) {
            // Choisir un indice de fréquence aléatoire dans la plage spécifiée
            let randomIndex = Math.floor(Math.random() * (config.frequencyRange[1] - config.frequencyRange[0] + 1)) + config.frequencyRange[0];
    
            // Assigner la même fréquence aux points symétriques
            assignedFrequencies[i] = randomIndex;
            assignedFrequencies[i + quarterPoints] = randomIndex;
            assignedFrequencies[i + 2 * quarterPoints] = randomIndex;
            assignedFrequencies[i + 3 * quarterPoints] = randomIndex;
        }
    }
    
    let rotationAngle = 0; // Définir un angle de rotation initial

    function drawSpectrum() {
        if (assignedFrequencies.length === 0) {
            assignFrequenciesSymmetrically();
        }
    
        averageFrequency();
        analyser.getByteFrequencyData(frequencyData);
    
        let points = frequencyData.length;
        let radius = config.circleRadius;
    
        clear();
    
        // Sauvegarde l'état actuel du contexte
        ctx.save();
    
        // Translater le contexte au centre du canvas
        ctx.translate(w / 2, h / 2);
    
        // Appliquer la rotation
        rotationAngle += 0.002; // Ajuster cette valeur pour changer la vitesse de rotation
        ctx.rotate(rotationAngle);
    
        // Translater le contexte en arrière
        ctx.translate(-w / 2, -h / 2);
    
        ctx.fillStyle = "white";
        ctx.strokeStyle = "white";
        ctx.lineWidth = 3;
    
        let smoothedValues = new Array(points).fill(0);
    
        for (let i = 0; i < points; i++) {
            let angle = Math.PI * 2 * i / points;
            let frequencyIndex = assignedFrequencies[i];
    
            let currentValue = frequencyData[frequencyIndex];
            smoothedValues[i] = smoothedValues[i] * config.smoothingFactor + currentValue * (1 - config.smoothingFactor);
    
            let normalizedFrequencyValue = Math.min(smoothedValues[i] * config.multiplier, config.maxTraitHeight);
    
            let x1 = w / 2 + radius * Math.cos(angle);
            let y1 = h / 2 + radius * Math.sin(angle);
            let x2 = w / 2 + (radius + normalizedFrequencyValue) * Math.cos(angle);
            let y2 = h / 2 + (radius + normalizedFrequencyValue) * Math.sin(angle);
    
            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.lineTo(x2, y2);
            ctx.stroke();
            ctx.closePath();
        }
    
        // Restaurer l'état original du contexte
        ctx.restore();
    }
    
    
    

    const clock = new THREE.Clock()
    let previousTime = 0
    let deltaTime = 0
    let elapsedTime = 0
    let runningTime = 0
    let requestSongSwap = false
    let missingBeatsToNextBar = 0
    let missingTimeToNextBar = 0

    function render(){
        elapsedTime = clock.getElapsedTime()
        deltaTime = elapsedTime - previousTime
        previousTime = elapsedTime

        if (playing) {
            runningTime += deltaTime
        }
        
        gsap.to('.animated-logo svg', {
            duration: 2,
            ease: "power2.out",
            rotation: runningTime * 170
        })
        
        clear()
        drawSpectrum()
        requestAnimationFrame(render)
        frequencyDataLen = analyser.frequencyBinCount;
        frequencyData = new Uint8Array(frequencyDataLen);
        analyser.getByteFrequencyData(frequencyData);
    }

    let avgFrq = null
    let avgFrqCheat = 1
    function averageFrequency(){
        avgFrq = 0
        if(frequencyData){
            for (let i = 0; i < frequencyData.length; i++){
                avgFrq += frequencyData[i]
            }
            avgFrq = avgFrq / avgFrqCheat
        }
        // console.log(avgFrq)
        return avgFrq
    }
    /**** END VISUALIZER ****/

    
    /**** BACKGROUND ****/
    App({ el: 'background' })
    let light1 = null;
    let light2 = null;
    let light3 = null;
    let light4 = null;
    let gArray = null;
    function App(conf) {
        conf = {
            fov: 75,
            cameraZ: 50,
            cameraY: 500,
            cameraX: 0,
            xyCoef: 3,
            zCoef: 9,
            lightIntensity: 1,
            ambientColor: new THREE.Color("#000000"),
            light1Color: new THREE.Color("#000000"),
            light2Color: new THREE.Color("#0096ff"),
            light3Color: new THREE.Color("#0096ff"),
            light4Color: new THREE.Color("#000000"),
            ...conf
        }

        let renderer = null
        let scene = null
        let camera = null
        let cameraCtrl = null
        let width = null
        let height = null
        let cx = null
        let cy = null
        let wWidth = null
        let wHeight = null
        // const TMath = THREE.Math


        let plane = null
        const simplex = new SimplexNoise()

        // const noiseInput = document.getElementById('noiseInput')
        // const heightInput = document.getElementById('heightInput')

        init()

        function init() {
            const width = window.clientWidth - scrollbarWidth
            const height = window.innerHeight
            const aspect = width / height

            renderer = new THREE.WebGLRenderer({ canvas: document.getElementById(conf.el), antialias: true, alpha: true })
            camera = new THREE.PerspectiveCamera(conf.fov, aspect , 0.01, 2000)
            
            updateSize()
            setTimeout(() => {
                updateSize() //pour reajuster le canvas
            }, 500)
            // window.addEventListener('resize', updateSize, false)
            
            initScene()
            // initGui()
            animate()
        }

 

        function initScene() {
            scene = new THREE.Scene()
            initLights()

            let mat = new THREE.MeshLambertMaterial({ color: 0xffffff, side: THREE.DoubleSide })
            let geo = new THREE.PlaneBufferGeometry(wWidth * 2, wHeight * 2, wWidth * 2, wHeight * 2)
            plane = new THREE.Mesh(geo, mat)
            scene.add(plane)

            plane.rotation.x = -Math.PI / 2 - 0.2
            plane.position.y = -100

            camera.position.z = conf.cameraZ
            camera.position.y = conf.cameraY
            camera.position.x = conf.cameraX
            camera.lookAt(plane.position)
            plane.scale.set(10, 10, 10)
        }

        function initLights() {
            const r = 300
            const y = 100
            const lightDistance = 5000

            light1 = new THREE.PointLight(conf.light1Color, conf.lightIntensity, lightDistance)
            light1.position.set(0, y, r)
            scene.add(light1)
            light2 = new THREE.PointLight(conf.light2Color, conf.lightIntensity, lightDistance)
            light2.position.set(0, -y, -r)
            scene.add(light2)
            light3 = new THREE.PointLight(conf.light3Color, conf.lightIntensity, lightDistance)
            light3.position.set(r, y, 0)
            scene.add(light3)
            light4 = new THREE.PointLight(conf.light4Color, conf.lightIntensity, lightDistance)
            light4.position.set(-r, y, 0)
            scene.add(light4)
        }

        function animate() {
            animatePlane()
            if (light1 != null) {
                animateLights() //decommenter pour point central
            }
            
            renderer.render(scene, camera)

            requestAnimationFrame(animate)
        }

        function animatePlane() {
            let avbg = avgFrq / 1.5
            
            if (avbg === null || playing === false) {
                avbg = 4000
            } else if (avbg < 4000 ){
                avbg = 4000 + Math.floor(Math.random() * 600) - 300
            } else if (avbg > 20000) {
                avbg = 20000 + Math.floor(Math.random() * 400) - 200
            }
            // console.log('avbg', avgFrq, avbg)
            
            gArray = plane.geometry.attributes.position.array
            const time = Date.now() * 0.0002
            for (let i = 0; i < gArray.length; i += 3) {
                // gArray[i + 2] = simplex.noise4D(gArray[i] / conf.xyCoef, gArray[i + 1] / conf.xyCoef, time, mouse.x + mouse.y) * conf.zCoef * (avbg/7500)
                gArray[i + 2] = simplex.noise3D(gArray[i] / conf.xyCoef, gArray[i + 1] / conf.xyCoef, time) * conf.zCoef * (avbg/7500)
            }
            plane.geometry.attributes.position.needsUpdate = true
            // plane.geometry.computeBoundingSphere()
        }

        function animateLights() {
            const time = Date.now() * 0.001
            const d = 50
            light1.position.x = Math.sin(time * 0.1) * d
            light1.position.z = Math.cos(time * 0.2) * d
            light2.position.x = Math.cos(time * 0.3) * d
            light2.position.z = Math.sin(time * 0.4) * d
            light3.position.x = Math.sin(time * 0.5) * d
            light3.position.z = Math.sin(time * 0.6) * d
            light4.position.x = Math.sin(time * 0.7) * d
            light4.position.z = Math.cos(time * 0.8) * d
        }

        function updateSize() {
            scrollbarWidth = window.innerWidth - document.querySelector('body').getBoundingClientRect().width;
            width = window.innerWidth - scrollbarWidth;
            height = window.innerHeight;
        
            // Ajuster la taille du renderer pour qu'il occupe tout l'espace disponible
            if (renderer) {
                renderer.setSize(width, height);
            }
        
            // Ajuster l'aspect de la caméra pour qu'elle corresponde au nouveau rapport largeur/hauteur
            if (camera) {
                camera.aspect = width / height;
                camera.updateProjectionMatrix();
            }
        
            // Ajuster les variables de taille de votre scène si nécessaire
            if (wWidth !== undefined && wHeight !== undefined) {
                const wsize = getRendererSize();
                wWidth = wsize[0];
                wHeight = wsize[1];
            }
        }
        
        window.addEventListener('resize', updateSize); // Ajouter un écouteur d'événements pour le redimensionnement de la fenêtre
        

        function getRendererSize() {
            const cam = new THREE.PerspectiveCamera(camera.fov, camera.aspect, 0.01, 2000)
            const vFOV = cam.fov * Math.PI / 180
            const height = 2 * Math.tan(vFOV / 2) * Math.abs(conf.cameraZ)
            const width = height * cam.aspect
            return [width, height]
        }
    }
    /**** END BACKGROUND ****/

    /**** CONTROLS SONGS ****/
    const context = new (window.AudioContext || window.webkitAudioContext)();
    const mesureDuration = 1.875; // Durée de 1 mesure en secondes
    const buffers = {};
    let firstAudioStartTime = null;
    let audios = {};
    let gainNodes = {};
    let pausedTracks = {};
    let firststart = true;

    

    let analyser = context.createAnalyser();
    analyser.fftSize = 256;
    analyser.smoothingTimeConstant = 0.8;
    let frequencyData = new Uint8Array(analyser.frequencyBinCount);

    analyser.connect(context.destination);

    function createGainNode(trackNumber) {
        const gainNode = context.createGain();
        gainNodes[trackNumber] = gainNode;
        gainNode.connect(analyser); // Connecter chaque gainNode à l'analyser
        return gainNode;
    }

    function startAudio(trackNumber, immediate = false, callback, buttonElement) {
        const source = context.createBufferSource();
        source.buffer = buffers[trackNumber];
        source.loop = true;
        
        const gainNode = gainNodes[trackNumber] || createGainNode(trackNumber);
        source.connect(gainNode).connect(context.destination);
        
        let startTime = firstAudioStartTime;
        let timeUntilNextMeasure = mesureDuration;
    
        if (immediate || firstAudioStartTime === null) {
            firstAudioStartTime = context.currentTime;
            startTime = context.currentTime;
        } else {
            let elapsedTime = context.currentTime - firstAudioStartTime;
            timeUntilNextMeasure = mesureDuration - (elapsedTime % mesureDuration);
            startTime = context.currentTime + timeUntilNextMeasure;
        }
    
        if (firststart === false) {
            if (buttonElement) {
                updateLoadingAnimation(buttonElement, timeUntilNextMeasure);
            }
        } else {
            if (buttonElement) {
                updateLoadingAnimation(buttonElement, 0);
            }
        }
    
        audios[trackNumber] = source;
        source.start(startTime);
    
        if (firststart === true) {
            render();
            firststart = false;
        }
    
        if (typeof callback === 'function') {
            source.onended = () => callback();
        }
    }
    
    function updateLoadingAnimation(button, duration) {
        const loadingElement = button.querySelector('.loading');
        const minDuration = .5; // Durée minimale en secondes
        const effectiveDuration = Math.max(duration, minDuration); // Utilisez la plus grande des deux valeurs
    
        // Animer avec GSAP
        gsap.to(loadingElement, {
            "--p": '100%',
            duration: effectiveDuration,
            ease: 'expo.out'
        });
    
        setTimeout(() => {
            button.classList.add('play');
        }, effectiveDuration * 1000);
    }
    
    function stopAudio(trackNumber, button) {
        if (audios[trackNumber]) {
            audios[trackNumber].stop();
            delete audios[trackNumber];
        }
    
        const loadingElement = button.querySelector('.loading');
    
        // Animer le retour à 0% avec GSAP
        gsap.to(loadingElement, {
            "--p": '0%',
            duration: 0.5, // Durée pour revenir à 0%
            ease: 'expo.out'
        });
    
        button.classList.remove('play');
    }
    
    

    function togglePlayPause() {
        if (Object.keys(audios).length > 0) {
        pausedTracks = { ...audios };
        Object.keys(audios).forEach(trackNumber => {
            playing = false;
            audios[trackNumber].stop();
            delete audios[trackNumber];
        });
        firstAudioStartTime = null;
        } else if (Object.keys(pausedTracks).length > 0) {
        Object.keys(pausedTracks).forEach(trackNumber => {
            playing = true;
            startAudio(Number(trackNumber), true);
        });
        pausedTracks = {};
        }
    }

    document.querySelectorAll('.volume-slider').forEach((slider, index) => {
        slider.addEventListener('input', () => {
        const trackNumber = index + 1;
        const volume = slider.value;
        if (gainNodes[trackNumber]) {
            gainNodes[trackNumber].gain.value = volume;
        }
        });
    });

    document.querySelectorAll('button[id^="piste-"]').forEach((button, index) => {
        button.addEventListener('click', () => {
            const trackNumber = index + 1;
            const nameElement = button.querySelector('.name');
    
            if (audios[trackNumber]) {
                playing = false;
                stopAudio(trackNumber, button);
                button.classList.remove('loading', 'active', 'play');
                // nameElement.innerHTML = `⏵︎ Piste ${trackNumber}`;                
                nameElement.innerHTML = '<i class="fa fa-play-circle"></i>';
                console.log(nameElement)
            } else {
                nameElement.innerHTML =  '<i class="fa fa-pause"></i>';
                button.classList.remove('loading');
                button.classList.add('active');

                playing = true;
                button.classList.add('loading');
                startAudio(trackNumber, false, null, button);
            }
        });
    });
    
    

    document.getElementById('pauseButton').addEventListener('click', togglePlayPause);

    // loadAudioTracks();
    // /**** END CONTROLS SONGS ****/
    // async function loadAudioTracks() {
    //     const fileNames = [
    //         './wp-content/themes/zekario/assets/songs/Stamp-1.mp3',
    //         './wp-content/themes/zekario/assets/songs/Stamp-2.mp3',
    //         './wp-content/themes/zekario/assets/songs/Stamp-3.mp3',
    //         './wp-content/themes/zekario/assets/songs/Stamp-4.mp3'
    //     ];

    //     const promises = fileNames.map((fileName, index) => {
    //         return fetch(fileName)
    //         .then(response => response.arrayBuffer())
    //         .then(arrayBuffer => context.decodeAudioData(arrayBuffer))
    //         .then(audioBuffer => {
    //             buffers[index + 1] = audioBuffer;
    //         });
    //     });

    //     await Promise.all(promises);
    // }
}